export class AddPatientModel {
  constructor(public FirstName: string,
              public LastName: string,
              public OrderId: number,
              public orderForMe: boolean,
              public MeAsPatient?: boolean) {
  }
}
